/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CreateProviderPropertyRequestDTO = {
    propertyName: string;
    propertyValue: string;
    providerName: CreateProviderPropertyRequestDTO.providerName;
};

export namespace CreateProviderPropertyRequestDTO {

    export enum providerName {
        OKHI = 'Okhi',
        SMILE = 'Smile',
        DOJAH = 'Dojah',
    }


}
